import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { redirect } from "react-router";

import LeagueStandings from "./LeagueStandings";

import { store } from "../..";
import "../../assets/css/majorybl/pages/leagues.scss";
import {
    leagueManagementActions,
    selectSelectedLeague,
} from "../../features/leaguemgmt/leagueManagementSlice";
import { useAppSelector } from "../../hooks/reduxHooks";
import { ILeague } from "../../types/api";

export const loader = async ({ params }: any) => {
    let { leagueId, teamId } = params;
    let league: ILeague | undefined;
    leagueId = parseInt(leagueId);
    teamId = parseInt(teamId);

    let leagues = store.getState().leaguemanagement.leagues;
    const leaguesPromise = leagues.length
        ? Promise.resolve()
        : store.dispatch(leagueManagementActions.getLeagues());

    const selectedLeague = selectSelectedLeague(store.getState());

    await Promise.all([leaguesPromise]);

    if (selectedLeague?.id !== leagueId) {
        store.dispatch(leagueManagementActions.setSelectedLeague(leagueId));
        league = selectSelectedLeague(store.getState());
    } else {
        league = selectedLeague;
    }

    const header = `${league?.ageLevel}${
        league?.designation ? ` ${league.designation}` : ""
    }${league?.direction ? ` ${league.direction}` : ""} Standings`;

    if (teamId && !league?.teams?.map(t => t.id).includes(teamId)) {
        return redirect(`/leagues/${leagueId}`);
    }

    return {
        league,
        header,
    };
};

const League = (): React.JSX.Element => {
    const league = useAppSelector(selectSelectedLeague);

    return (
        <div data-testid="leagueContent">
            <Container className="league py-2 py-lg-0" fluid="xs">
                <Row>
                    <Col>
                        <h2>Standings</h2>
                        <LeagueStandings data={league} expanded bordered />
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default League;
